// Modules
import cn from 'classnames';

// Types
import type { TTabProps } from './Tabs.type';

// Styles
import styles from './styles/styles.module.scss';

// Constants
import { TAB_DEFAULT_PROPS } from './Tab.constant';

const Tab = (props: TTabProps) => {
	const {
		active,
		children,
		className,
		// Will be used in the future once the the UI is ready
		// disabled,
		onClick,
		position = TAB_DEFAULT_PROPS.position,
		...restProps
	} = props;

	const tabCN = cn(styles.legion_tab, className, styles[position!], {
		[styles.active]: active,
		// Will be used in the future once the the UI is ready
		// [styles.disabled]: disabled
	});

	const handleClick = () => {
		// Will be used in the future once the the UI is ready
		// if (disabled) return;
		onClick && onClick()
	}

	return (
		<div className={tabCN} onClick={handleClick} {...restProps}>
			{children}
		</div>
	);
}

export default Tab;
